import {getCookie} from 'config/cookies';
import {TENANT_INFO, USER_NAME} from 'constants/Main';

export default () => {
  const hoscoUsername = getCookie(USER_NAME);
  const hoscoRefreshToken = getCookie('hosco_refreshToken');
  const userInfo = getCookie('user_info');
  const tenantInfo = getCookie(TENANT_INFO);
  return {hoscoUsername, hoscoRefreshToken, userInfo, tenantInfo};
};
